(function() {
  const transparentPages = [
    'page.la-nostra-struttura',
    'page.grecale',
    'page.libeccio',
    'page.maestrale',
    'page.levante'
  ];

  const main = document.querySelector('[data-template]');
  if (!main) return;

  const template = main.getAttribute('data-template');
  if (!transparentPages.includes(template)) return;

  const header = document.querySelector('header-component');
  if (!header) return;

  header.setAttribute('transparent', 'not-sticky');
  header.classList.add('color-scheme-6');
})();
